import { render, staticRenderFns } from "./zs.vue?vue&type=template&id=ecd30d24&scoped=true"
import script from "./zs.vue?vue&type=script&lang=js"
export * from "./zs.vue?vue&type=script&lang=js"
import style0 from "./zs.vue?vue&type=style&index=0&id=ecd30d24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd30d24",
  null
  
)

export default component.exports